// 3rd party
import * as React from 'react';
import { inject, observer } from 'mobx-react';

// Bernie
import { AnalyticsStore, ContextStore, RouteStore } from 'bernie-core';

// UI Toolkit
import { UitkCardPlaceholder } from 'uitk-react-cards';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';

// Components
import { ProductCard } from 'components/products/product-card';

// Models
import { Product, Program } from 'models';

// Stores
import ProgramStatus from 'stores/ProgramStatus';

// Utils
import { modifyLocaleParam } from '../../util/LocaleParamTransformer';

interface ProductProps {
  analytics?: AnalyticsStore;
  context?: ContextStore;
  products?: Product[];
  program?: Program;
  programStatus?: string;
  routeStore?: RouteStore;
}

@inject('analytics', 'context', 'products', 'routeStore')
@observer
class Products extends React.Component<ProductProps> {
  public render() {
    const { analytics, context, products, program, programStatus, routeStore } = this.props;

    const currentLocale = modifyLocaleParam(context.locale);

    const cards = products
      .filter((product) => product.isEnabled)
      .map((product) => {
        const isPreview = [null, ProgramStatus.UNKNOWN, ProgramStatus.PENDING].includes(programStatus);

        product.link = product.link?.replace(':localeName', currentLocale);

        return (
          <UitkLayoutGridItem key={product.name}>
            <ProductCard
              analytics={analytics}
              product={product}
              program={program}
              programStatus={programStatus}
              routeStore={routeStore}
              locale={currentLocale}
              isPending={programStatus === ProgramStatus.PENDING}
              isPreview={isPreview}
              showActions={true}
            />
          </UitkLayoutGridItem>
        );
      });

    return (
      <main className="container">
        <UitkLayoutGrid columns={{ small: 1, large: 2, extra_large: 3 }} space="four">
          {products?.length === 0 &&
            [...Array(9)].map((val, index) => (
              <div key={index}>
                <UitkCardPlaceholder aspectRatio="r1-1" />
              </div>
            ))}

          {cards}
        </UitkLayoutGrid>
      </main>
    );
  }
}

export { Products };
